import { useAuthStore } from '@/stores/auth'
import { useNotificationsStore } from '@/stores/notifications'

let refresh_token_tries = 0

// token refresh function
const obtainNewAccessToken = async function () {
    console.log('> obtainNewAccessToken')

    const auth_store = useAuthStore()
    const apihost = useAppConfig().API_HOST

    let payload = auth_store.refresh_token_getter ? { refresh_token: auth_store.refresh_token_getter } : {}

    try {
        console.log(payload)
        const response = await fetch(apihost + '/token', {
            method: 'PATCH',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
            server: false,
        })

        console.log('> obtainNewAccessToken - Success')

        if (response.status === 202) {
            let data = await response.json()
            auth_store.save_refresh_token(data.access_token, data.refresh_token)
            console.log('New tokens saved into Auth Store')
            return data.access_token
        } else if (response.status === 401) {
            let data = await response.json()
            // console.log(data.detail)
            if (data.detail) {
                const { makeNotification } = useNotificationsStore()
                makeNotification(data.detail, 'error')
                auth_store.user_logout()
            }
        } else {
            throw new Error('Failed to refresh token')
        }
    } catch (error) {
        console.error('> obtainNewAccessToken - Error', error)
        throw error
    }
}

export const req = function (url, method = 'GET', body = null, error_toast = true) {
    // error_toast - if disabled, we don't show error message toast and return error back to the caller

    const { makeNotification } = useNotificationsStore()

    return new Promise(async (resolve, reject) => {
        try {
            const response = await makeRequest(url, method, body)
            resolve(response)
        } catch (error) {
            console.warn('> req - First Attempt Error', error)

            if (error.status > 500) {
                makeNotification(`Server error (${error.status}). Try again later.`, 'error')
                console.warn(typeof error, error)
                reject(error)
            }

            let content = await error.json()

            if (error.status === 401 && (await content.detail.includes('Signature Expired'))) {
                console.log('trying to refresh')
                if (refresh_token_tries < 3) {
                    refresh_token_tries++
                    try {
                        // Attempt to refresh the token
                        await obtainNewAccessToken()
                        // Retry the original request with the new token
                        const retryResponse = await makeRequest(url, method, body)
                        resolve(retryResponse)
                    } catch (retryError) {
                        console.error('> req - Retry Attempt Error', retryError)
                        reject(retryError)
                    }
                } else {
                    console.log('Too many token refresh attempts')
                    throw new Error('Too many token refresh attempts')
                }
            } else if (content.detail) {
                // if we got .detail field, again have two possibilites:
                // 1. it's an error message itself as string
                // 2. it's an error object with .msg field
                // so check it...

                if (typeof content.detail == 'object' && content.detail.length == 1) {
                    content.detail = content.detail[0].msg
                }

                if (error_toast) {
                    if (error.status === 401) {
                        // making 401 unauthorized toast yellow - like no error
                        makeNotification(content.detail, 'info')
                    } else {
                        makeNotification(content.detail, 'warning')
                    }
                }

                // if (error_toast) makeNotification(content.detail.replace('Not authenticated', 'Please sign in'), 'error');
                // auth_store.user_logout()
                reject(content.detail)
                // throw new Error(content.detail);
            } else {
                // throw error;
                console.warn(typeof error, error)
                reject(error)
            }
        }
    })
}

// Separated makeRequest function to simplify retry logic
async function makeRequest(url, method = 'GET', raw_body = null) {
    const auth_store = useAuthStore()
    const apihost = useAppConfig().API_HOST

    url = url.replace(':api:', apihost)

    // console.log(url);
    let headers = auth_store.access_token_getter ? { Authorization: 'Bearer ' + auth_store.access_token_getter } : {}

    // console.log('h', headers)

    let body = null
    if (raw_body) {
        if (raw_body instanceof FormData) {
            body = raw_body
        } else {
            body = JSON.stringify(raw_body)
            headers['Content-Type'] = 'application/json'
        }
    }

    const response = await fetch(url, {
        method: method,
        headers: headers,
        body: body,
        server: false,
    })

    if (response.status >= 200 && response.status < 300) {
        return await response.json()
    } else {
        // const text = await response.text();

        // if(response.status === 500){
        //     throw "Server Error";
        // }

        // throw await response.json();
        throw response
    }
}
